import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BadgeContainer = ({
  title = '',
  subtitle = '',
  children = null,
  isComplete = true,
  showCheck = false,
  showLine = false,
  boldLine = false,
  badgeSize = 'md',
}) => {
  // badgeSize prop / css class match.
  const badgeSizes = {
    sm: 'small',
    md: 'medium', // assumed default in css
    // "lg":"large",
    // "xl":"xlarge"
  };

  const lineClasses = clsx('line', {
    'line--bold': boldLine,
  });

  return (
    <div className="badgeContainer">
      <div className="containerHeader">
        {title.length > 0 && <h1 className="badgeContainer__title">{title}</h1>}
        {showCheck && (
          <div className={`check ${isComplete ? 'completed' : ''}`}>
            <FontAwesomeIcon icon={['fas', 'check-circle']} size="2x" />
          </div>
        )}
      </div>
      {subtitle.length > 0 && <h2 className="badgeContainer__subtitle">{subtitle}</h2>}
      <div className={`badgeGrid ${badgeSizes[badgeSize]}`}>{children}</div>
      {showLine && <div className={lineClasses} />}
    </div>
  );
};

BadgeContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  isComplete: PropTypes.bool,
  showLine: PropTypes.bool,
  boldLine: PropTypes.bool,
  showCheck: PropTypes.bool,
  badgeSize: PropTypes.oneOf(['sm', 'md']),
};

export default BadgeContainer;
